import { render, staticRenderFns } from "./EsportsBracket.vue?vue&type=template&id=baa41a18&scoped=true"
import script from "./EsportsBracket.vue?vue&type=script&setup=true&lang=js"
export * from "./EsportsBracket.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EsportsBracket.vue?vue&type=style&index=0&id=baa41a18&prod&scoped=true&lang=css"
import style1 from "./EsportsBracket.vue?vue&type=style&index=1&id=baa41a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa41a18",
  null
  
)

export default component.exports